import React, { PropTypes} from 'react'
import { connect } from 'react-redux';

import { Button, Modal } from 'react-bootstrap';
import { hideModal } from '../../actions/ModalAction'

import TextareaAutosize from '../../components/forms/TextareaAutosize';


var replyMessage = ''

function handleBodyChange(e){
  replyMessage = e.target.value;
}

const ConfirmModal = ({ isModalOpen, onConfirm, onCancel}) => (

  <Modal show={isModalOpen} >

    <Modal.Body>
      <div className="row">
        <form className="smart-form">

          <fieldset>
            <label className="textarea">
              <TextareaAutosize className="form-control" placeholder="Content" onResize={() => {}} rows="5" onChange={handleBodyChange} />
            </label>
          </fieldset>

        </form>
      </div>
    </Modal.Body>

    <Modal.Footer>
      <Button onClick={onCancel}>Cancel</Button>
      <Button bsStyle="primary" onClick={ () => onConfirm(replyMessage)}>OK</Button>
    </Modal.Footer>

  </Modal>
)

ConfirmModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default connect()(ConfirmModal)



// WEBPACK FOOTER //
// ./src/pages/modal/ContactReplyModal.js